"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DOCTOR_AVAILABILITY_DEFAULT_DURATION_MINUTES () {
        return DOCTOR_AVAILABILITY_DEFAULT_DURATION_MINUTES;
    },
    get DOCTOR_AVAILABILITY_LIST_MAX_ITEMS () {
        return DOCTOR_AVAILABILITY_LIST_MAX_ITEMS;
    },
    get DOCTOR_AVAILABILITY_MAX_DURATION_MINUTES () {
        return DOCTOR_AVAILABILITY_MAX_DURATION_MINUTES;
    },
    get DOCTOR_AVAILABILITY_MAX_INTERVALS () {
        return DOCTOR_AVAILABILITY_MAX_INTERVALS;
    },
    get DOCTOR_AVAILABILITY_MAX_INTERVALS_PER_WEEKDAY () {
        return DOCTOR_AVAILABILITY_MAX_INTERVALS_PER_WEEKDAY;
    },
    get DOCTOR_AVAILABILITY_MIN_DURATION_MINUTES () {
        return DOCTOR_AVAILABILITY_MIN_DURATION_MINUTES;
    },
    get DoctorAvailabilityDocumentSchema () {
        return DoctorAvailabilityDocumentSchema;
    },
    get DoctorAvailabilityIntervalInputSchema () {
        return DoctorAvailabilityIntervalInputSchema;
    },
    get DoctorAvailabilityIntervalSchema () {
        return DoctorAvailabilityIntervalSchema;
    },
    get DoctorAvailabilityListItemSchema () {
        return DoctorAvailabilityListItemSchema;
    },
    get DoctorAvailabilityListResponseSchema () {
        return DoctorAvailabilityListResponseSchema;
    },
    get DoctorAvailabilityUpdateRequestSchema () {
        return DoctorAvailabilityUpdateRequestSchema;
    },
    get DoctorAvailabilityWeekSchema () {
        return DoctorAvailabilityWeekSchema;
    }
});
const _zod = require("zod");
const _time = require("./time");
const DOCTOR_AVAILABILITY_MAX_INTERVALS_PER_WEEKDAY = 6;
const DOCTOR_AVAILABILITY_MAX_INTERVALS = 42;
const DOCTOR_AVAILABILITY_MIN_DURATION_MINUTES = 5;
const DOCTOR_AVAILABILITY_MAX_DURATION_MINUTES = 120;
const DOCTOR_AVAILABILITY_DEFAULT_DURATION_MINUTES = 30;
const DOCTOR_AVAILABILITY_LIST_MAX_ITEMS = 500;
const intervalShape = {
    branchId: _zod.z.string().uuid(),
    weekday: _time.IsoWeekdaySchema,
    start: _time.ClinicTimeSchema,
    end: _time.ClinicTimeSchema
};
const durationMinutes = _zod.z.number({
    message: 'Default duration must be a number of minutes.'
}).int({
    message: 'Default duration must be whole minutes.'
}).min(DOCTOR_AVAILABILITY_MIN_DURATION_MINUTES, {
    message: `Default duration must be at least ${DOCTOR_AVAILABILITY_MIN_DURATION_MINUTES} minutes.`
}).max(DOCTOR_AVAILABILITY_MAX_DURATION_MINUTES, {
    message: `Default duration must be at most ${DOCTOR_AVAILABILITY_MAX_DURATION_MINUTES} minutes.`
});
const DoctorAvailabilityIntervalInputSchema = _zod.z.object({
    ...intervalShape,
    defaultDurationMinutes: durationMinutes.default(DOCTOR_AVAILABILITY_DEFAULT_DURATION_MINUTES)
}).strict().refine((interval)=>interval.end > interval.start, {
    message: 'End must be after start.',
    path: [
        'end'
    ]
});
const DoctorAvailabilityWeekSchema = _zod.z.array(DoctorAvailabilityIntervalInputSchema).max(DOCTOR_AVAILABILITY_MAX_INTERVALS, {
    message: 'Too many intervals.'
}).superRefine((intervals, ctx)=>{
    const perWeekday = new Map();
    for (const interval of intervals){
        perWeekday.set(interval.weekday, (perWeekday.get(interval.weekday) ?? 0) + 1);
    }
    for (const count of perWeekday.values()){
        if (count > DOCTOR_AVAILABILITY_MAX_INTERVALS_PER_WEEKDAY) {
            ctx.addIssue({
                code: 'custom',
                message: `A weekday can have at most ${DOCTOR_AVAILABILITY_MAX_INTERVALS_PER_WEEKDAY} intervals.`
            });
            return;
        }
    }
    if ((0, _time.findOverlappingWeekday)(intervals) !== null) {
        ctx.addIssue({
            code: 'custom',
            message: 'Intervals on one weekday must not overlap, even at different clinics.'
        });
    }
}).transform((intervals)=>[
        ...intervals
    ].sort((a, b)=>a.weekday - b.weekday || a.start.localeCompare(b.start)));
const DoctorAvailabilityUpdateRequestSchema = _zod.z.object({
    version: _zod.z.number({
        message: 'version must be a number.'
    }).int({
        message: 'version must be a whole number.'
    }).min(0, {
        message: 'version must be 0 or more.'
    }),
    intervals: DoctorAvailabilityWeekSchema
}).strict();
const DoctorAvailabilityIntervalSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    ...intervalShape,
    defaultDurationMinutes: durationMinutes
}).strict();
const DoctorAvailabilityDocumentSchema = _zod.z.object({
    userId: _zod.z.string().uuid(),
    displayName: _zod.z.string().nullable(),
    version: _zod.z.number().int().min(0),
    intervals: _zod.z.array(DoctorAvailabilityIntervalSchema)
}).strict();
const DoctorAvailabilityListItemSchema = _zod.z.object({
    userId: _zod.z.string().uuid(),
    displayName: _zod.z.string().nullable(),
    status: _zod.z.enum([
        'active',
        'suspended',
        'invited'
    ]),
    intervalCount: _zod.z.number().int().min(0),
    version: _zod.z.number().int().min(0)
}).strict();
const DoctorAvailabilityListResponseSchema = _zod.z.object({
    items: _zod.z.array(DoctorAvailabilityListItemSchema).max(DOCTOR_AVAILABILITY_LIST_MAX_ITEMS)
}).strict();
